import React from 'react';

import { EntryFeature } from '../ui/split-feature/EntryFeature';
import type { Work } from '../../content/types/work';
import { getWorkPath } from '../../content';

type WorkListProps = {
  works: Work[];
};

export const WorkList: React.FC<WorkListProps> = ({ works }) => {
  return (
    <div>
      {works.map((work, index) => (
        <EntryFeature
          key={work.id}
          entry={work}
          placement={index % 2 === 0 ? 'Right' : 'Left'}
          detailPath={getWorkPath(work.slug)}
        />
      ))}
    </div>
  );
};
